module.exports = __webpack_public_path__ + "static/img/city2.a4c1e0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/contact/city2.png
// module id = AMHm
// module chunks = 1